import React, { useState, useEffect } from "react";
import axios from "axios";

const MyAccountPage = ({ onLogout }) => {
    const [info, setInfo] = useState(null);
    const [loading, setLoading] = useState(true);
    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [message, setMessage] = useState("");
    const [passwordValidationMessage, setPasswordValidationMessage] = useState("");

    const token = localStorage.getItem("auth_token");

    useEffect(() => {
        if (!token) {
            setMessage("로그인이 필요합니다.");
            return;
        }

        axios.post(`${process.env.REACT_APP_API_BASE_URL}/employees/me`, { token })
            .then((res) => {
                setInfo(res.data);
            })
            .catch(() => {
                setMessage("내 정보를 불러오지 못했습니다.");
            })
            .finally(() => setLoading(false));
    }, [token]);

    // ✅ 비밀번호 복잡성 체크 함수
    const isPasswordComplexEnough = (password) => {
        return password.length >= 8 &&
            /[A-Z]/.test(password) &&    // 대문자
            /[a-z]/.test(password) &&    // 소문자
            /\d/.test(password) &&       // 숫자
            /[!@#$%^&*()]/.test(password); // 특수문자
    };

    const handleNewPasswordChange = (e) => {
        const value = e.target.value;
        setNewPassword(value);

        if (!value) {
            setPasswordValidationMessage(""); // 비워두기
            return;
        }

        if (isPasswordComplexEnough(value)) {
            setPasswordValidationMessage("사용가능한 비밀번호 입니다!");
        } else {
            setPasswordValidationMessage("비밀번호는 8자 이상, 대문자, 소문자, 숫자, 특수문자를 모두 포함해야 합니다.");
        }
    };

    const handleChangePassword = async () => {
        if (!oldPassword || !newPassword) {
            setMessage("기존 비밀번호와 새 비밀번호를 입력하세요.");
            return;
        }

        try {
            const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/employees/change_password`, {
                email: info.email,
                oldPassword,
                newPassword
            });

            setMessage(res.data.message);
            setOldPassword("");
            setNewPassword("");
            setPasswordValidationMessage("");

            alert("비밀번호가 성공적으로 변경되었습니다!");

        } catch (err) {
            setMessage(err.response?.data?.message || "비밀번호 변경 실패");
        }
    };

    if (loading) {
        return <div>로딩 중...</div>;
    }

    if (!info) {
        return <div>{message}</div>;
    }

    return (
        <div className="max-w-md mx-auto mt-10 p-6 bg-white rounded-lg shadow">
            <h2 className="text-2xl font-bold mb-4">내 정보</h2>
            <p><strong>이름:</strong> {info.name}</p>
            <p><strong>이메일:</strong> {info.email}</p>
            <p><strong>부서:</strong> {info.department}</p>
            <p><strong>직급:</strong> {info.position}</p>
            <p><strong>권한:</strong> {info.role}</p>

            <div className="mt-6">
                <h3 className="text-xl font-semibold mb-2">비밀번호 변경</h3>

                <input
                    type="password"
                    placeholder="기존 비밀번호"
                    value={oldPassword}
                    onChange={(e) => setOldPassword(e.target.value)}
                    className="border p-2 w-full mb-2"
                />
                <input
                    type="password"
                    placeholder="새 비밀번호 (8자 이상, 대소문자, 숫자, 특수문자 포함)"
                    value={newPassword}
                    onChange={handleNewPasswordChange}
                    className="border p-2 w-full mb-1"
                />
                {/* ✅ 복잡성 메시지 표시 */}
                {passwordValidationMessage && (
                    <p className={`text-sm ${isPasswordComplexEnough(newPassword) ? "text-green-500" : "text-red-500"}`}>
                        {passwordValidationMessage}
                    </p>
                )}

                <button
                    onClick={handleChangePassword}
                    className="bg-blue-500 text-white p-2 w-full rounded hover:bg-blue-600 mt-4"
                >
                    비밀번호 변경
                </button>
            </div>

            {message && <p className="mt-4 text-center text-red-500">{message}</p>}
        </div>
    );
};

export default MyAccountPage;